/**
 * @file 회의록 API
 * 부서별 회의록(회의 날짜 단위) CRUD + 수정 이력 조회 + 참조 데이터(부서·현재 사용자·전 직원).
 */
import { api } from "../../../util/api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const B = `${API_BASE}/meeting-minutes`;

export const meetingMinutesApi = {
    // ─── 회의록 ──────────────────────────────────────────────────
    // params: { deptId?, week? } — week 는 그 주 아무 날짜(서버가 월요일로 정규화)
    getList: (params = {}) => api.get(B, params),
    get:     (id)     => api.get(`${B}/${id}`),
    getRevisions: (id) => api.get(`${B}/${id}/revisions`),
    create:  (data)     => api.post(B, data),
    update:  (id, data) => api.put(`${B}/${id}`, data),
    remove:  (id)       => api.delete(`${B}/${id}`),

    // ─── 첨부파일 ────────────────────────────────────────────────
    getAttachments:   (id) => api.get(`${B}/${id}/attachments`),
    uploadAttachment: (id, file) => {
        const form = new FormData();
        form.append("file", file);
        return api.upload(`${B}/${id}/attachments`, form);
    },
    removeAttachment: (attachmentId) => api.delete(`${B}/attachment/${attachmentId}`),
    /** 첨부 미리보기 (blob). PDF·이미지·엑셀·텍스트는 원본, 오피스는 서버 PDF 변환. */
    previewAttachment: (attachmentId) => api.download(`${B}/attachment/${attachmentId}/preview`),

    // ─── 참조 데이터 ─────────────────────────────────────────────
    getDepartments: () => api.get(`${API_BASE}/employees/departments`),
    getMe:          () => api.get(`${API_BASE}/employees/me`),
    /** 전 직원 간단 목록 — 참석자 "우리 부서 전원 추가"용.
     *  EmployeeSimpleDto: { id, name, employeeCode, deptId, deptName, positionName } */
    getEmployees:   () => api.get(`${API_BASE}/employees`),

    // ─── 휴가·부재 (결재 승인분) ─────────────────────────────────
    // 결재 도메인의 승인된 휴가+출장 조회. deptId 주면 그 부서만, 없으면 전 부서.
    // from/to = "YYYY-MM-DD".
    getLeaves: (deptId, from, to) =>
        api.get(`${API_BASE}/approval/leaves`,
            { from, to, ...(deptId != null ? { deptIds: deptId } : {}) }),
};
